import React, { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useRecoilValue } from 'recoil';

import { Theme } from '@constants';
import { useShowNextLDLProduct } from '@hooks';
import { ldlPlaylistState } from '@store';

import { ldlPlaylist } from './ldlPlaylist';

import { isWeb } from '../../../helpers/Platform';

export const LDLDebugShortcuts = () => {
  const playlist = ldlPlaylist;
  const { activeProductIndex, isAnimationEnabled } = useRecoilValue(ldlPlaylistState);
  const showNextProduct = useShowNextLDLProduct();

  const useTVEventHandler = require('react-native').useTVEventHandler || (() => null);

  const ffHandler = event => {
    if (
      event?.keyCode === 228 ||
      event?.keyCode === 70 ||
      event?.keyCode === 90 ||
      event?.eventType === 'fastForward' // for Google TV, run `adb shell input keyevent 90` for FF button
    ) {
      showNextProduct(true);
    }
  };

  useTVEventHandler(ffHandler);

  useEffect(() => {
    isWeb && document.addEventListener('keydown', ffHandler);
    return () => {
      isWeb && document.removeEventListener('keydown', ffHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeProductIndex]);

  return (
    <View style={styles.wrapper}>
      <Text
        style={styles.text}
      >{`Active LDL: ${playlist[activeProductIndex]}. Animating: ${isAnimationEnabled}. FF to go to next.`}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  text: {
    color: Theme.white,
    fontSize: Theme.px(20),
    padding: Theme.px(2),
  },
  wrapper: {
    alignItems: 'center',
    backgroundColor: '#222222',
    bottom: Theme.px(4),
    elevation: 5,
    justifyContent: 'center',
    opacity: 0.4,
    position: 'absolute',
    right: Theme.px(10),
    zIndex: 5,
  },
});
